import React from "react";

const EditIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.07152 13.6429H14.0715M2.07153 13.6429H3.1879C3.51402 13.6429 3.67708 13.6429 3.83053 13.6069C3.96658 13.575 4.09664 13.5224 4.21593 13.451C4.35049 13.3705 4.46579 13.258 4.69639 13.0329L13.0716 4.85682C13.6239 4.31766 13.6239 3.44352 13.0716 2.90437C12.5193 2.36521 11.6238 2.36521 11.0716 2.90437L2.69637 11.0804C2.46577 11.3055 2.35047 11.4181 2.26801 11.5495C2.19491 11.6659 2.14104 11.7929 2.10837 11.9257C2.07153 12.0755 2.07153 12.2347 2.07153 12.553V13.6429Z" stroke={props.color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default EditIcon;